import HorizontalMenu from "../components/horizontalMenu";
import MyChallengesCard from "../components/MyChallengesCard";
import { useEffect, useState } from "react";
import "../components/ChallengeCard.css";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/esm/Button";
import getTodayDate from "../utils/currentDate";
import Cookies from "js-cookie";
import ClipLoader from "react-spinners/ClipLoader";
import axiosInstance from "../utils/axiosInstance";
import Pagination from 'react-bootstrap/Pagination';

function MyChallenges() {
  const authToken = Cookies.get("authToken");
  const [myChallengesArray, setMyChallengesArray] = useState([]);
  const [showCNCmodal, setShowCNCModal] = useState(false);
  const [currentUser, setCurrentUser] = useState("");
  const [showActivityListModal, setShowActivityListModal] = useState(false);
  const initialDailyTasksArray = Array.from({ length: 21 }, () => "");
  const [dailyTasks, setDailyTasks] = useState(initialDailyTasksArray);
  const [isLoading, setIsLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const challengesPerPage = 4;
  const totalPages = Math.ceil(myChallengesArray.length / challengesPerPage)

  const startIndex = (currentPage - 1) * challengesPerPage;
  const currentChallenges = myChallengesArray.sort((a, b) => b.start_date.localeCompare(a.start_date)).slice(startIndex, startIndex + challengesPerPage)
  

 
  let items = [];
  for (let number = 1; number <= totalPages; number++) {
    items.push(
      <Pagination.Item key={number} onClick={() => goToPage(number)} active={number === currentPage}>
        {number}
      </Pagination.Item>,
    );
  }

  const defaultChallengeFormData = {
    username: "",
    title: "21 Day Challenge",
    description: "No description",
    rules: "No rules",
    startDate: getTodayDate(),
    privacyLevel: "Private",
  };

  const [challengeFormData, setChallengeFormData] = useState(defaultChallengeFormData);

  const loadMyChallenges = (headers) => {
    return axiosInstance
      .get(`/challenges/private`, { headers })
      .then((response) => {
        setMyChallengesArray(response.data);
        setIsLoading(false);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    const headers = {
      Authorization: `Bearer ${authToken}`,
      "Content-Type": "application/json",
    };

    loadMyChallenges(headers);

    axiosInstance
      .get(`/users/user`, { headers })
      .then((response) => {
        setCurrentUser(response.data.username);
      })
      .catch((error) => {});
  }, []);

  const override = {
    display: "block",
    margin: "0 auto",
  };

  const handleInputChange = (event) => {
    setChallengeFormData({
      ...challengeFormData,
      [event.target.name]: event.target.value,
    });
  };

  const createChallenge = (event) => {
    event.preventDefault();

    if (dailyTasks.some((value) => value === undefined || value === "")) {
      console.log("Please write a task for all 21 days.");
      return;
    }

    const newChallenge = {
      ...challengeFormData,
      username: currentUser,
      tasks: dailyTasks,
    };

    console.log("Challenge Form Data: ", newChallenge);

    axiosInstance
      .post("/challenges/create", newChallenge)
      .then((response) => {
        setShowCNCModal(false);
        setShowActivityListModal(false);
        setChallengeFormData(defaultChallengeFormData);
        setDailyTasks(initialDailyTasksArray);
        loadMyChallenges({
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        });
      })
      .catch((error) => {});
  };

  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  }

  const handleMyChallengesArrayDeletion = (challenge_oid) => {
    // This is used in the child component to modify the state of myChallengesArray
    const updatedChallengesArray = myChallengesArray.filter(
      (challenge_item) => challenge_item._id !== challenge_oid
    );
    setMyChallengesArray(updatedChallengesArray);
  };

  const getChallengeTasks = (challenge) => {
    return challenge.records.map((record) => {
      const currentUserCompletion = record.completions.find(
        (completion) => completion.username === currentUser
      );
      return currentUserCompletion?.activity || record.completions[0]?.activity || "";
    });
  };

  const handleRecreateChallenge = (challenge) => {
    setChallengeFormData({
      ...defaultChallengeFormData,
      title: challenge.title,
      description: challenge.description,
      privacyLevel: challenge.private_challenge === false ? "Public" : "Private",
      startDate: getTodayDate(),
    });
    setDailyTasks(getChallengeTasks(challenge));
    setShowCNCModal(true);
  };

  const renderDailyTasks = () => {
    const days = [];
    let placeholder = "";

    for (let i = 0; i < 21; i++) {
      if (i < 7) {
        placeholder = "Example: Learn a new word.";
      } else if (7 <= i && i < 14) {
        placeholder = "Example: Learn two new words.";
      } else {
        placeholder = "Example: Learn three new words.";
      }

      days.push(
        <div key={i}>
          Day {i + 1}{" "}
          <Form.Control
            placeholder={placeholder}
            type="input"
            value={dailyTasks[i]}
            onChange={(e) => handleDailyTasksInput(i, e.target.value)}
            required
          />
        </div>
      );
    }
    return days;
  };

  const handleDailyTasksInput = (index, value) => {
    const tasks = [...dailyTasks];
    tasks[index] = value;
    setDailyTasks(tasks);
  };

  return (
    <div>
      <HorizontalMenu />

      <div>
        {/* <button
          className="new-challenge-button"
          onClick={() => setShowCNCModal(true)}
          disabled={true}
        >
          Create New Challenge
        </button>  */}
      </div>
      <div>
        <ClipLoader loading={isLoading} cssOverride={override} />
      </div>

      {myChallengesArray.length === 0
        ? "No Challenges"
        : currentChallenges
            
            // .filter(item => {
            //   const today = new Date();
            //   const diffInTime = today - new Date(item.start_date); 
            //   const diffInDays = diffInTime / (1000 * 3600 * 24);
            //   return diffInDays >= 0 && diffInDays <= 21; 
            // })
            .map((challenge_item) => {
              return (
                <MyChallengesCard
                  key={challenge_item._id}
                  title={challenge_item.title}
                  description={challenge_item.description}
                  startDay={challenge_item.start_date}
                  organizer={challenge_item.organizer}
                  records={challenge_item.records}
                  participants={challenge_item.participant_ids}
                  spectators={challenge_item.spectator_ids}
                  challenge_oid={challenge_item._id}
                  currentUser={currentUser}
	                  comments={challenge_item.comments}
	                  handleMyChallengesArray={handleMyChallengesArrayDeletion}
	                  icon={challenge_item.icon}
	                  onRecreate={() => handleRecreateChallenge(challenge_item)}
	                />
	              );
	            })}

  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
    <Pagination size="lg">{items}</Pagination>
  </div>


      <Modal
        show={showCNCmodal}
        size="lg"
        onHide={() => setShowCNCModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Create New Challenge
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
	              placeholder="Cooking Healthy Food Challenge"
	              name="title"
	              value={challengeFormData.title}
	              onChange={handleInputChange}
	              autoFocus
	            />
            <Form.Label>Description</Form.Label>
            <Form.Control
              type="text"
	              placeholder="Our ultimate goal to save money and feel healthier by..."
	              name="description"
	              value={challengeFormData.description}
	              onChange={handleInputChange}
	            />
            <Form.Label>Start Date</Form.Label>
            <Form.Control
	              type="date"
	              min={getTodayDate()}
	              value={challengeFormData.startDate}
	              name="startDate"
	              onChange={handleInputChange}
	            />
            <Form.Label>Privacy Level</Form.Label>
            <Form.Control
	              as="select"
	              name="privacyLevel"
	              value={challengeFormData.privacyLevel}
	              onChange={handleInputChange}
	            >
              <option value="Private">Private</option>
              <option value="Public">Public</option>
            </Form.Control>
          </Form>
        </Modal.Body>
        <Button
          onClick={() => {
            setShowCNCModal(false);
            setShowActivityListModal(true);
          }}
        >
          Continue
        </Button>
      </Modal>

      <Modal
        show={showActivityListModal}
        size="lg"
        backdrop="static"
        onHide={() => setShowActivityListModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Daily Tasks</Modal.Title>
        </Modal.Header>
        <Form className="challenge-task-form" onSubmit={createChallenge}>
          {renderDailyTasks()}
          <Button variant="success" type="submit" className="w-100 mt-3">
            Create
          </Button>
        </Form>
      </Modal>
    </div>
  );
}

export default MyChallenges;
